/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ls_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Line Sorter — Sort Lines Alphabetically & Numerically | Toolverse`)
};

const es_ls_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenador de líneas — Ordena líneas alfabética y numéricamente | Toolverse`)
};

const de_ls_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Line Sorter — Zeilen alphabetisch & numerisch sortieren | Toolverse`)
};

const nl_ls_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regelsortering — Sorteer regels alfabetisch en numeriek | Toolverse`)
};

const fr_ls_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trieur de lignes — Trier les lignes alphabétiquement et numériquement | Toolverse`)
};

const it_ls_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordinatore di linee — Ordina le linee alfabeticamente e numericamente | Toolverse`)
};

const pt_br2_ls_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenador de Linhas — Ordene Linhas Alfabética e Numericamente | Toolverse`)
};

const pt_ls_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificador de Linhas — Classifique Linhas Alfabeticamente e Numericamente | Toolverse`)
};

const ja_ls_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行ソーター — 行をアルファベット順と数値順にソート | Toolverse`)
};

const zh_ls_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行排序工具 — 按字母顺序和数字顺序排列文本行 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ls_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ls_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ls_meta_title", locale)
	if (locale === "en") return en_ls_meta_title(inputs)
	if (locale === "es") return es_ls_meta_title(inputs)
	if (locale === "de") return de_ls_meta_title(inputs)
	if (locale === "nl") return nl_ls_meta_title(inputs)
	if (locale === "fr") return fr_ls_meta_title(inputs)
	if (locale === "it") return it_ls_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_ls_meta_title(inputs)
	if (locale === "pt") return pt_ls_meta_title(inputs)
	if (locale === "ja") return ja_ls_meta_title(inputs)
	return zh_ls_meta_title(inputs)
};